import { IconArrowLeft } from '@tabler/icons-react';
import { classNames } from '../classNames';
import { Link } from './Link';

export function BackLink({
  href,
  label,
  className,
}: {
  href: string;
  label: string;
  className?: string;
}) {
  return (
    <div className={classNames(className)}>
      <Link
        href={href}
        className="text-link hover:bg-cream focus-visible:outline-brand-dark portal-press inline-flex items-center gap-2 rounded-md px-3 py-2 text-base font-medium no-underline focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <IconArrowLeft size={16} aria-hidden />
        {label}
      </Link>
    </div>
  );
}
